module.exports = __webpack_public_path__ + "static/img/one.136acdb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/elephant/one.png
// module id = /fjX
// module chunks = 1